/**
 * Утилита для генерации "умного шума" и имитации живой динамики данных.
 */

// Парсит строку вида "60+M", "153K", "42,853" в число
const parseStatValue = (val) => {
    if (typeof val !== 'string') return val;
    let numeric = parseFloat(val.replace(/,/g, '').replace(/[^\d.]/g, ''));
    let multiplier = 1;
    if (val.toLowerCase().includes('m')) multiplier = 1000000;
    else if (val.toLowerCase().includes('k')) multiplier = 1000;
    return numeric * multiplier;
};

// Форматирует число обратно в строку с сохранением суффиксов
const formatStatValue = (num, originalStr) => {
    if (typeof originalStr !== 'string') return num;

    if (originalStr.toLowerCase().includes('m')) {
        return (num / 1000000).toFixed(originalStr.includes('.') ? 1 : 0) + (originalStr.includes('+') ? '+M' : 'M');
    }
    if (originalStr.toLowerCase().includes('k')) {
        return (num / 1000).toFixed(0) + 'K';
    }
    if (originalStr.includes('%')) {
        return Math.min(100, Math.max(0, num)).toFixed(0) + '%';
    }
    if (originalStr.includes(',')) {
        return Math.floor(num).toLocaleString('en-US');
    }
    return Math.floor(num).toString();
};

/**
 * Генерирует небольшое изменение для значения.
 * @param {string} currentVal - Текущее строковое значение (н-р "60+M")
 * @param {object} options - Настройки (maxChange: процент, trend: 'up'|'down'|'neutral')
 */
export const getNextStatValue = (currentVal, options = {}) => {
    const { maxChange = 0.0001, trend = 'up' } = options;
    const numeric = parseStatValue(currentVal);

    let changePercent;
    if (trend === 'up') {
        changePercent = Math.random() * maxChange;
    } else if (trend === 'down') {
        changePercent = -Math.random() * maxChange;
    } else {
        changePercent = (Math.random() - 0.5) * 2 * maxChange;
    }

    const newValue = numeric * (1 + changePercent);
    return formatStatValue(newValue, currentVal);
};

/**
 * Имитирует "умный шум" через синусоиду для более плавных колебаний (например, для Rate или Online)
 */
export const getSmoothNoise = (baseVal, amplitude = 0.02) => {
    const time = Date.now() / 10000;
    const noise = Math.sin(time) * amplitude + (Math.random() - 0.5) * (amplitude * 0.5);
    const numeric = parseStatValue(baseVal);
    return formatStatValue(numeric * (1 + noise), baseVal);
};